import React, { useState } from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import DetailsForm from './components/DetailsForm/DetailsForm';

const StyledBox = styled(Box)(({ theme }) => ({
  height: 'calc(100vh - 8rem)',
  overflow: 'auto',
  backgroundColor: theme.palette.common.white,
  border: '1px solid',
  borderColor: theme.palette.booking.borderBox,
  padding: '1rem',
  '& .MuiTabs-indicator': {
    display: 'none'
  }
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  maxWidth: '100%',
  width: '50%',
  fontSize: '14px',
  backgroundColor: theme.palette.common.white,
  '&.Mui-selected': {
    backgroundColor: theme.palette.booking.info,
    color: theme.palette.common.black,
    border: 0
  }
}));

const StyledTabs = styled(Tabs)(() => ({
  fontSize: '20px'
}));

const DetailsAndEvents = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  };

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };

  return (
    <StyledBox sx={{ width: '100%' }}>
      <Box sx={{ border: 1, borderColor: 'divider' }}>
        <StyledTabs value={value} onChange={handleChange} aria-label='basic tabs example'>
          <StyledTab label={Localize.get('MyProfile.details')} {...a11yProps(0)} />
          <StyledTab disabled label={Localize.get('MyProfile.events')} {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <DetailsForm />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        Item Two
      </CustomTabPanel>
    </StyledBox>
  );
};
export default DetailsAndEvents;
